import dayjs from 'dayjs'
export function fnDateEn(date = new Date()) {
  return dayjs(date).locale('en')
}
